import React, { FC } from 'react'
import MugshotModal from './mugshots/component/MugshotModal'
import SearchForm from './search/components/SearchForm'
import BookingsList from './bookings/components/BookingsList'
import Disclaimer from './Disclaimer'
import { useBookingIsSelected, useModalOnKeyUp } from './mugshots/hooks'

const App: FC = () => {
  const bookingIsSelected = useBookingIsSelected()
  useModalOnKeyUp()

  var containerClass = `container-fluid${bookingIsSelected ? " faded" : ""}`;
  return (
    <main className="government light department">
      <div>
        <MugshotModal />
        <div className={containerClass} id="mainContent">
          <div className="row-fluid">
            <SearchForm />
            <Disclaimer />
          </div>
          <BookingsList />
        </div>
      </div>
    </main>
  )
}

export default App